import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { TwoStepVarificationComponent } from './two-step-varification/two-step-varification.component';



const routes: Routes = [
  {
    path: 'sign-in',
    component: SignInComponent,
    data: { title: ':: Postman :: Sign In' }
  },

  {
    path: 'sign-up',
    component: SignUpComponent,
    data: { title: ':: Postman :: Sign Up' }
  },

  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: { title: ':: Postman :: Reset-password' }
  },

  {
    path: 'error-page',
    component: ErrorPageComponent,
    data: { title: ':: Postman :: 404-Error' }
  },

  {
    path: 'two-step-varification',
    component: TwoStepVarificationComponent,
    data: { title: ':: Postman :: Two-step-varification' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
  static components = [
  ];

}
